module.exports = __webpack_public_path__ + "static/media/Renekton.ca547a93.png";